<template>
  <router-view />
</template>

<script>
  export default {
    name: 'App',
    metaInfo () {
      return {
        title: 'VOD',
        titleTemplate:
          '%s | VOD',
      }
    },
    created () {
    },
    methods: {
    },
  }
</script>
